export class CashRegisterZReportBulkLocalRequest {
    cashRegisterId?: number;
    accessToken?: string;
    startDate?: Date;
    endDate?: Date;
} 